var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepIconLeft2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "43px",
    viewBox: "0 0 45 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "step-icon-left-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.665333333 0 34.0003333 0 34.0003333 39.9996667 0.665333333 39.9996667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.0001,18 C8.7441,18 8.4881,17.902 8.2931,17.707 L4.2931,13.707 C3.9021,13.316 3.9021,12.684 4.2931,12.293 C4.6841,11.902 5.3161,11.902 5.7071,12.293 L9.0001,15.586 L18.2931,6.293 C18.6841,5.902 19.3161,5.902 19.7071,6.293 C20.0981,6.684 20.0981,7.316 19.7071,7.707 L9.7071,17.707 C9.5121,17.902 9.2561,18 9.0001,18",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Widget-/-Help-/-Icon-/-Seguro",
    transform: "translate(-25.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Padding-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-L-/-Margin-/-Seguro-/-1",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Escudo",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 40 40 40 40 0 0 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(2.666667, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3328333,2.02083333 C22.6378333,6.56916667 29.2545,7.70583333 32.3161667,7.99083333 C31.7978333,30.9341667 19.9511667,36.9325 17.3395,37.9775 C14.8011667,36.9308333 2.87616667,30.8025 2.3495,7.99083333 C5.41116667,7.7075 12.0278333,6.56916667 17.3328333,2.02083333",
    id: "Fill-2",
    fill: "#E3B750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06866667,9.70633333 C7.43033333,9.21466667 12.7136667,7.90466667 17.3336667,4.408 L17.3336667,36.408 C14.287,34.9463333 4.96533333,28.9196667 4.06866667,9.70633333 M17.332,-0.000333333333 C10.6653333,6.668 0.665333333,6.66633333 0.665333333,6.66633333 C0.665333333,34.9996667 17.332,39.9996667 17.332,39.9996667 C17.332,39.9996667 34.0003333,34.9996667 34.0003333,6.66633333 C33.9936667,6.66633333 23.9986667,6.66633333 17.332,-0.000333333333",
    id: "Fill-4",
    fill: "#C8A046",
    mask: "url(#mask-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(1.000000, 1.000000)",
    fill: "#E3B750"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.2397,0.1938 L3.4267,1.0668 C3.5887,1.8208 4.1787,2.4108 4.9327,2.5728 L5.8057,2.7598 C6.0647,2.8158 6.0647,3.1838 5.8057,3.2398 L4.9327,3.4268 C4.1787,3.5898 3.5887,4.1788 3.4267,4.9338 L3.2397,5.8068 C3.1837,6.0648 2.8157,6.0648 2.7607,5.8068 L2.5727,4.9338 C2.4107,4.1788 1.8217,3.5898 1.0667,3.4268 L0.1937,3.2398 C-0.0643,3.1838 -0.0643,2.8158 0.1937,2.7598 L1.0667,2.5728 C1.8217,2.4108 2.4107,1.8208 2.5727,1.0668 L2.7607,0.1938 C2.8157,-0.0652 3.1837,-0.0652 3.2397,0.1938",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7793,32.2261 L41.9983,33.2451 C42.1873,34.1251 42.8753,34.8131 43.7553,35.0021 L44.7743,35.2211 C45.0753,35.2861 45.0753,35.7151 44.7743,35.7801 L43.7553,35.9991 C42.8753,36.1881 42.1873,36.8761 41.9983,37.7561 L41.7793,38.7741 C41.7153,39.0761 41.2843,39.0761 41.2203,38.7741 L41.0023,37.7561 C40.8123,36.8761 40.1253,36.1881 39.2443,35.9991 L38.2253,35.7801 C37.9253,35.7151 37.9253,35.2861 38.2253,35.2211 L39.2443,35.0021 C40.1253,34.8131 40.8123,34.1251 41.0023,33.2451 L41.2203,32.2261 C41.2843,31.9251 41.7153,31.9251 41.7793,32.2261",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1597,39.1294 L37.2847,39.7114 C37.3927,40.2144 37.7857,40.6074 38.2887,40.7154 L38.8707,40.8404 C39.0427,40.8774 39.0427,41.1224 38.8707,41.1604 L38.2887,41.2854 C37.7857,41.3934 37.3927,41.7864 37.2847,42.2894 L37.1597,42.8714 C37.1227,43.0434 36.8767,43.0434 36.8407,42.8714 L36.7157,42.2894 C36.6067,41.7864 36.2147,41.3934 35.7117,41.2854 L35.1287,41.1604 C34.9567,41.1224 34.9567,40.8774 35.1287,40.8404 L35.7117,40.7154 C36.2147,40.6074 36.6067,40.2144 36.7157,39.7114 L36.8407,39.1294 C36.8767,38.9574 37.1227,38.9574 37.1597,39.1294",
    id: "Fill-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Basics-/-Tick",
    transform: "translate(12.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-900",
    mask: "url(#mask-4)",
    fill: "#202020",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIconLeft2);
export default __webpack_public_path__ + "static/media/step-icon-left-2.532b39c5090b0e8a8f5d324ac9f8f33f.svg";
export { ForwardRef as ReactComponent };